import * as React from "react";

import ClassNames from "classnames";
import InputLabel from "../InputLabel";
import Typography from "../Typography";
import Styles from "./Toggle.module.css";

export interface Props {
  value?: string;
  className?: string;
  label: string;
  hideLabel?: boolean;
  helperText?: string;
  errors?: string[];
  id: string;
  inputRef?: any;
  required?: boolean;
  nativeRequired?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Toggle: React.FC<Props> = props => {
  const {
    value,
    className,
    id,
    errors,
    onChange,
    label,
    hideLabel,
    helperText,
    required,
    nativeRequired,
    inputRef
  } = props;

  return (
    <div className={Styles.wrapper}>
      <InputLabel
        label={label}
        htmlFor={id}
        required={required}
        nativeRequired={nativeRequired}
        hideLabel={hideLabel}
      />
      <div className={Styles.container}>
        <input
          className={ClassNames({
            [Styles.toggle]: true
          })}
          type="checkbox"
          id={id}
          onChange={onChange}
          value={value}
          ref={inputRef}
          required={nativeRequired}
        />
        <label
          htmlFor={id}
          className={ClassNames({
            [Styles.switch]: true,
            [className]: className
          })}
        />
      </div>
      {helperText && (
        <Typography body="small" className={Styles.helper}>
          {helperText}
        </Typography>
      )}
      {errors &&
        errors.map((error, i) => {
          return (
            <Typography
              body="small"
              className={ClassNames({
                [Styles.error]: true,
                [Styles.firstError]: errors.length !== 1 && i === 0
              })}
              key={`error-${id}-${i}`}
            >
              {error}
            </Typography>
          );
        })}
    </div>
  );
};

export default Toggle;
